<template>
  <div>
    <home-header></home-header>
    <div class="content page-width">
      <personal-center></personal-center>
      <div class="margin-top-30"></div>
      <a-spin :spinning="gradeSpinning">
      <plan-list :arrs="arrs" :gradeData="gradeData" :time="time" @get="getGradeData" v-if="gradeData"></plan-list>
      </a-spin>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import HomeHeader from '@/common/components/Header'
import Foot from '@/common/components/Foot'
import PlanList from './components/PlanList'
import PersonalCenter from '@/common/components/PersonalCenter'
import axios from 'axios'
export default {
  name: 'MyScore',
  components: {
    HomeHeader,
    Foot,
    PlanList,
    PersonalCenter
  },
  data() {
    return {
      arrs: [],
      gradeData:[],
      time: null,
      gradeSpinning: true
    }
  },
  methods: {
    getDetailInfo () {
      this.gradeSpinning = true;
      axios.get('/biz/score/mine').then(res=>{
        if(res.success){
          this.gradeSpinning = false;
          let data = res.result
          console.log(data)
          // let arr = []
          // for (let i = 0; i < data.length; i+=2) {
          //   const element = data[i];
          //   const element1 = data[i+1];
          //   let arr1 = [element,element1];
          //   arr.push(arr1)
          // }
          this.gradeData = data
          this.time = res.timestamp
        }
      })
    },
    handleGetDataSucc (res) {
      res = res.data
      if (res.ret && res.data) {
        const data = res.data
        this.arrs = data.plan
        console.log(this.arrs)
      }
    },
    getGradeData (msg) {
      console.log(msg)
      if (msg === 1) {
        this.getDetailInfo()
      }
    }
  },
  mounted () {
    this.getDetailInfo()
  }
}
</script>
<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  .page-width{
    width:$pageWidth;
    margin:0 auto;
    .content-right{
      margin-top:30px;
      .localtion{
        line-height 30px;
        border-bottom:1px solid $borderColor;
        margin-bottom:20px;
      }
    }
  }
  .content-left{
    background:#f7f6f6;
  }
</style>



// WEBPACK FOOTER //
// src/pages/myscore/Index.vue